const routes = [
  {
    path: "/partner/list",
    name: "partners-list",
    component: () => import("@/views/partners/partner/List.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/partner/edit/:id?",
    name: "partner-edit",
    component: () => import("@/views/partners/partner/Edit.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/partner-view/edit/:id?",
    name: "partner-view-edit",
    component: () =>
      import("@/views/partners/partner-view/PartnerViewCreateOrUpdate"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/partner-view/list",
    name: "partner-views-list",
    component: () => import("@/views/partners/partner-view/PartnerViewList"),
    meta: {
      layout: "content",
      resource: "partner-view",
      action: "read",
    },
  },
  {
    path: "/partner-account/list",
    name: "partner-accounts-list",
    component: () => import("@/views/partners/partner_account/List.vue"),
    meta: {
      layout: "content",
      resource: "partner-account",
      action: "read",
    },
  },
  {
    path: "/partner-account/edit/:id?",
    name: "partner-account-edit",
    component: () => import("@/views/partners/partner_account/Edit.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/partner/data",
    name: "partner-account-data",
    component: () => import("@/views/partners/partner_data/PartnerData.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/partner-relation/list",
    name: "partner-relations-list",
    component: () => import("@/views/partners/partner_relation/List.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/partner-relation/edit/:id?",
    name: "partner-relation-edit",
    component: () => import("@/views/partners/partner_relation/Edit.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/partner-view-group/list",
    name: "partner-view-groups-list",
    component: () => import("@/views/partners/partner-view-group/List"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/partner-view-group/edit/:id?",
    name: "partner-view-group-edit",
    component: () => import("@/views/partners/partner-view-group/Edit"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
];

export default routes;
